export default __webpack_public_path__ + "static/media/path2.35e76a63.png";